/**
 * @generated SignedSource<<89e37e9096d6d0fc488451f9e3c0184f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_jqlBuilder_JQLBuilderUI_hydrationQueryData$data = {
  readonly jira?: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery?: {
        readonly __typename: string;
      } | null | undefined;
      readonly hydrateJqlQueryForFilter?: {
        readonly __typename: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"jqlEditor_jqlBuilderBasic_JQLEditorUI" | "useHydratedValues" | "useHydratedValues_cascadeSelectPicker" | "useQuery">;
  readonly " $fragmentType": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData";
};
export type ui_jqlBuilder_JQLBuilderUI_hydrationQueryData$key = {
  readonly " $data"?: ui_jqlBuilder_JQLBuilderUI_hydrationQueryData$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_jqlBuilder_JQLBuilderUI_hydrationQueryData">;
};

import HydrationRefetchQuery_graphql from './HydrationRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "accountId"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "filterAri"
    },
    {
      "kind": "RootArgument",
      "name": "includeJira"
    },
    {
      "kind": "RootArgument",
      "name": "includeUser"
    },
    {
      "kind": "RootArgument",
      "name": "isFilter"
    },
    {
      "kind": "RootArgument",
      "name": "jql"
    },
    {
      "kind": "RootArgument",
      "name": "viewContext"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": HydrationRefetchQuery_graphql
    }
  },
  "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useHydratedValues"
    },
    {
      "kind": "FragmentSpread",
      "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
    },
    {
      "kind": "FragmentSpread",
      "name": "useQuery"
    },
    {
      "kind": "FragmentSpread",
      "name": "useHydratedValues_cascadeSelectPicker"
    },
    {
      "condition": "includeJira",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "query",
                          "variableName": "jql"
                        },
                        (v0/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQuery",
                      "plural": false,
                      "selections": (v1/*: any*/)
                    }
                  ]
                },
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "id",
                          "variableName": "filterAri"
                        },
                        (v0/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQueryForFilter",
                      "plural": false,
                      "selections": (v1/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "c68222eec6395468da06c55f73b3f4e6";

export default node;
